// npm
import React from 'react'
import { createRoot } from 'react-dom/client'
import {
  BrowserRouter,
} from "react-router-dom"
import {
   QueryClient,
   QueryClientProvider,
} from 'react-query'
import {
  RecoilRoot,
} from 'recoil'

// local
import App from './App.jsx'

// setup
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // globally default to 60s
      staleTime: 60 * 1000,
    },
  },
})

// mount the React app
const app = document.querySelector('#app')
const root = createRoot(app)
root.render(
  <BrowserRouter>
    <QueryClientProvider client={ queryClient }>
      <RecoilRoot>
        <App />
      </RecoilRoot>
    </QueryClientProvider>
  </BrowserRouter>
)
